const updates = [
  {
    date: '08.01',
    title: '《锦绣芳华》大结局超前点播已上线',
    desc: '年度古装传奇大剧迎来大结局，会员可提前解锁最后三集，精彩不容错过。',
    tag: '重磅',
  },
  {
    date: '07.31',
    title: '悬疑剧场专区全新改版上线',
    desc: '悬疑推理类剧集独立分区，新增剧情时间线功能，追剧体验全面升级。',
    tag: '功能',
  },
  {
    date: '07.29',
    title: '暑期档特别企划：经典老剧限时回归',
    desc: '《甄嬛传》《琅琊榜》《步步惊心》等经典剧集高清修复版上线，重温经典。',
    tag: '专题',
  },
  {
    date: '07.27',
    title: '播放器内核升级，加载速度提升40%',
    desc: '全新播放器V3.0版本上线，智能预加载和多线路自动切换，追剧更流畅。',
    tag: '技术',
  },
  {
    date: '07.25',
    title: '韩剧频道新增12部独家同步剧集',
    desc: '与韩国三大电视台达成内容合作，热门韩剧实现隔日中字同步更新。',
    tag: '内容',
  },
  {
    date: '07.22',
    title: '追剧日历功能上线，不再错过更新',
    desc: '新增追剧日历模块，支持订阅提醒，剧集更新推送通知让追剧更有计划。',
    tag: '功能',
  },
  {
    date: '07.20',
    title: '番茄影视大全用户突破5000万',
    desc: '感谢每一位追剧小伙伴的支持，我们将继续优化服务，带来更多精彩内容。',
    tag: '里程碑',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-600">番茄影视大全近期更新与重要公告</p>
        </div>
        <div className="relative">
          <div className="absolute left-5 top-0 bottom-0 w-px bg-background-300/60 hidden sm:block"></div>
          <div className="space-y-5">
            {updates.map((update, idx) => (
              <div key={idx} className="flex gap-4 sm:gap-6">
                <div className="hidden sm:flex flex-col items-center pt-1 flex-shrink-0">
                  <span className="w-2.5 h-2.5 rounded-full bg-primary-500 relative z-10"></span>
                </div>
                <div className="flex-1 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className="text-xs font-semibold text-primary-600 whitespace-nowrap">{update.date}</span>
                    <span className="text-[10px] px-1.5 py-0.5 bg-accent-100 text-accent-700 rounded whitespace-nowrap">{update.tag}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">{update.title}</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">{update.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}